import { DateTime } from 'luxon'
import { makeAutoObservable } from 'mobx'
import * as apiClient from 'src/utils/apiClient/webApplications'

type RegisterParams = Omit<apiClient.RegisterParams, 'moveInOn'> & {
  moveInOn: DateTime
}

export default class WebApplicationStore {
  // Constructor ------------

  constructor() {
    makeAutoObservable(this)
  }

  // Actions ---------------

  getAccountTransferEditParams = async (params: apiClient.GetAccountTransferEditParamsParams) => {
    return await apiClient.getAccountTransferEditParams(params)
  }

  getCreditCardEditURL = async (params: apiClient.GetCreditCardEditURLParams) => {
    const { url } = await apiClient.getCreditCardEditURL(params)
    return url
  }

  register = async (params: RegisterParams) => {
    const { info } = await apiClient.register({
      ...params,
      moveInOn: params.moveInOn.toFormat('yyyy-MM-dd'),
    })
    return info
  }
}
